import './navigation.js';
import './skip-link-focus-fix.js';
(( $ ) => {


	$(document).ready( () => {

		// piilottaa suolaisten painikkeet sivun latautuessa, koska makeat on oletusvalinta
		$('.facetwp-facet-suolaisten_alakategoriat').addClass('hide-me');

		// painettaessa mobiilissa reseptien suodatusnappia
		$('#reseptien-suodatusnappi').click(function(){

			if ( $('#reseptien-suodattimet').hasClass('hidden') ) {
				$('#reseptien-suodattimet').removeClass('hidden');
				$('#reseptien-suodatusnappi').text('Piilota suodattimet');
			} else {
				$('#reseptien-suodattimet').addClass('hidden');
				$('#reseptien-suodatusnappi').text('Suodata reseptejä');
			}

			
		});

		// painettaessa makeiden kategorianappia
		$('#makeat-kategoria-nappi').click(function(){
			// nollaa facetit
			FWP.reset();
			// poista punainen alareuna kaikista elementeistä
			$('#kategoria-napit > div').removeClass('recipe-type-active');
			// palauta kuvat normaaleiksi
			$('#makeat-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/makeat_tumma.png');
			$('#suolaiset-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/suolaiset_tumma.png');
			$('#reseptihaku-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/reseptit_tumma.png');

			// näyttää makeiden painikkeet (jos oli piilossa)
			$('.facetwp-facet-makeiden_alakategoriat').removeClass('hide-me');
			// näyttää avainsanat
			$('.facetwp-facet-reseptien_avainsanat').removeClass('hide-me');
			// piilottaa suolaisten painikkeet
			$('.facetwp-facet-suolaisten_alakategoriat').addClass('hide-me');
			// piilota hakupalkki
			$('#reseptihakuboksi').addClass('hidden');
			// näytä viiva
			$('#facetwp-kategoriat').addClass('border-b-4');

			// lisää punainen alareuna makeiden nappiin
			$(this).addClass('recipe-type-active');
			// vaihda makeiden kuva punaiseksi
			$('#makeat-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/makeat.png');
		});

		// painettaessa suolaisten kategorianappia
		$('#suolaiset-kategoria-nappi').click(function(){
			// nollaa facetit
			FWP.reset();
			// poista punainen alareuna kaikista elementeistä
			$('#kategoria-napit > div').removeClass('recipe-type-active');
			// palauta kuvat normaaleiksi
			$('#makeat-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/makeat_tumma.png');
			$('#suolaiset-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/suolaiset_tumma.png');
			$('#reseptihaku-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/reseptit_tumma.png');

			// näyttää suolaisten painikkeet (jos oli piilossa)
			$('.facetwp-facet-suolaisten_alakategoriat').removeClass('hide-me');
			// näyttää avainsanat
			$('.facetwp-facet-reseptien_avainsanat').removeClass('hide-me');
			// piilottaa makeiden painikkeet
			$('.facetwp-facet-makeiden_alakategoriat').addClass('hide-me');
			// piilota hakupalkki
			$('#reseptihakuboksi').addClass('hidden');
			// näytä viiva
			$('#facetwp-kategoriat').addClass('border-b-4');

			// lisää punainen alareuna suolaisten nappiin
			$(this).addClass('recipe-type-active');
			// vaihda suolaisten kuva punaiseksi
			$('#suolaiset-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/suolaiset.png');
		});

		// painettaessa reseptihaun kategorianappia
		$('#reseptihaku-kategoria-nappi').click(function(){
			// nollaa facetit
			FWP.reset();
			// poista punainen alareuna kaikista elementeistä
			$('#kategoria-napit > div').removeClass('recipe-type-active');
			// palauta kuvat normaaleiksi
			$('#makeat-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/makeat_tumma.png');
			$('#suolaiset-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/suolaiset_tumma.png');
			$('#reseptihaku-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/reseptit_tumma.png');

			// piilottaa suolaisten, makeiden ja avainsanojen painikkeet
			$('.facetwp-facet-makeiden_alakategoriat').addClass('hide-me');
			$('.facetwp-facet-suolaisten_alakategoriat').addClass('hide-me');
			$('.facetwp-facet-reseptien_avainsanat').addClass('hide-me');
			// poista viiva
			$('#facetwp-kategoriat').removeClass('border-b-4');

			// näytä hakupalkki
			$('#reseptihakuboksi').removeClass('hidden');

			// lisää punainen alareuna reseptihaun nappiin
			$(this).addClass('recipe-type-active');
			// vaihda reseptihaun kuva punaiseksi
			$('#reseptihaku-img').attr('src', '/wp-content/themes/terveelliset-herkut/assets/images/reseptit.png');
		});

		// yläpalkin hakupainike mobiilissa
		$('#search-button').click(function(){
			if ( $('#search-area').hasClass('hidden') ) {
				$('#search-area').removeClass('hidden');
				$('#search-area').addClass('flex');
			} else {
				$('#search-area').addClass('hidden');
				$('#search-area').removeClass('flex');
			}
		});

		// yläpalkin hakupainike työpöydällä
		$('#search-button-lg').click(function(){
			if ( $('#search-area-lg').hasClass('hidden') ) {
				$('#search-area-lg').removeClass('hidden');
				$('#search-area-lg').addClass('flex');
			} else {
				$('#search-area-lg').addClass('hidden');
				$('#search-area-lg').removeClass('flex');
			}
		});

	});


	/* optional triggers

	$(window).load(() => {

	});

	$(window).resize(() => {

	});

	*/


} )( jQuery );



// WEBPACK FOOTER //
// ./assets/js/app.js